import { useContext } from "react";

import ResearchWrite03 from "../Upsert/ResearchWrite03";
import ResearchList03 from "./ResearchList03";
import { AuthContext } from "../../../context/AuthProvider";
import { useLocation } from "react-router-dom";

const Research03 = ({ boardCode}) => {
  const { isAdmin } = useContext(AuthContext);
  const location = useLocation();
  const isWriteMode = location.state?.isWriteMode || false;
   if (isAdmin) {
    return isWriteMode ? (
      <ResearchWrite03 boardCode={boardCode} />
    ) : (
      <ResearchList03 boardCode={boardCode} />
    );
  }

  return <ResearchWrite03 boardCode={boardCode} />;
};

export default Research03;
